// const CryptoJS = require("crypto-js");

import CryptoJS from 'crypto-js';
import {Base64} from 'js-base64';
const keyLength = new Array(32);
/**
 * [encrypt 加密]
 * @return {[type]} [description]
 */
function encryptAes(content, token) {
  let key = Base64.encode(token).substring(0, keyLength.length);
  let iv = ""; // 偏移量
  key = CryptoJS.enc.Utf8.parse(key);
  iv = CryptoJS.enc.Utf8.parse(iv);
  let srcs = CryptoJS.enc.Utf8.parse(JSON.stringify(content));
  // 加密模式为ECB，补码方式为PKCS5Padding（也就是PKCS7）
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  //返回base64
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}
function encryptHMAC(content, token) {
  let key = Base64.encode(Base64.encode(token).substring(0, keyLength.length));
  key = CryptoJS.enc.Utf8.parse(key);
  let srcs = CryptoJS.enc.Utf8.parse(content);
  var hash = CryptoJS.HmacSHA1(srcs, key);
  return CryptoJS.enc.Base64.stringify(hash);
}

/**
 * [decrypt 解密]
 * @return {[type]} [description]
 */
function decrypt(text, key) {
  let decryptKey = Base64.encode(key).substring(0, keyLength.length);
  let newText=text.replace(/\n/g, "")
  let baseResult = CryptoJS.enc.Base64.parse(newText.replace(/\r/g, "")); // Base64解密
  let ciphertext = CryptoJS.enc.Base64.stringify(baseResult); // Base64解密
  let decryptResult = CryptoJS.AES.decrypt(
    ciphertext,
    CryptoJS.enc.Utf8.parse(decryptKey),
    {
      //  AES解密
      iv: CryptoJS.enc.Utf8.parse(""),
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  let resData = decryptResult.toString(CryptoJS.enc.Utf8).toString();
  return resData;
}

export { encryptAes, encryptHMAC, decrypt };
